import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const API = '/api';

export const useProducts = (categories) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchProducts = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get(`${API}/products`);
      const cats = categories ? categories.split(',') : null;
      setProducts(cats ? response.data.filter((p) => cats.includes(p.category)) : response.data);
    } catch (err) {
      setError('Unable to load products. Please try again.');
    } finally {
      setLoading(false);
    }
  }, [categories]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  return { products, loading, error, retry: fetchProducts };
};
